// The Bills list as a spreadsheet (Stephanie 2026-10-22: "Bills: supplier
// filter + download"). One row per bill, in the order shown, each cell made
// safe for Excel / Google Sheets (csvCell). Pure — the offline gate runs it.
import { csvCell } from "./csv";

export interface BillCsvRow {
  vendorName: string;
  vendorBillNumber: string | null;
  poNumber: number | null;
  billDate: string;
  dueDate: string | null;
  status: string;
  total: string | null;
  paidAt: string | null;
}

export const BILL_CSV_HEADER = ["Supplier", "Supplier bill #", "PO #", "Bill date", "Due date", "Status", "Total", "Paid on"];

export function billsToCsv(rows: readonly BillCsvRow[], statusWords: (s: string) => string): string {
  const lines = [BILL_CSV_HEADER.map(csvCell).join(",")];
  for (const r of rows) {
    lines.push([
      r.vendorName,
      r.vendorBillNumber,
      r.poNumber,
      r.billDate,
      r.dueDate,
      statusWords(r.status),
      r.total === null ? "" : Number(r.total).toFixed(2),
      r.paidAt ? r.paidAt.slice(0, 10) : "",
    ].map(csvCell).join(","));
  }
  return lines.join("\r\n") + "\r\n";
}

/** "bills-sanmar-overdue-2026-10-22.csv" */
export function billsCsvName(parts: ReadonlyArray<string | null | undefined>, today: string): string {
  const slug = parts.filter(Boolean).join("-").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
  return `bills${slug ? `-${slug}` : ""}-${today}.csv`;
}
